export default __webpack_public_path__ + "static/media/ethics.34af8bb0.svg";